/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_IconInputs */

const en_tables_custom_pages_icon = /** @type {(inputs: Tables_Custom_Pages_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages Icon`)
};

const de_tables_custom_pages_icon = /** @type {(inputs: Tables_Custom_Pages_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icon`)
};

/**
* | output |
* | --- |
* | "Pages Icon" |
*
* @param {Tables_Custom_Pages_IconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_icon = /** @type {((inputs?: Tables_Custom_Pages_IconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_IconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_icon(inputs)
	return de_tables_custom_pages_icon(inputs)
});